<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'Adhibition',
}
</script>

<style scoped>

</style>
